"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductApiTypesHelper = void 0;
var fs = __importStar(require("fs"));
var CommonTypesHelper_1 = require("./CommonTypesHelper");
var ProductApiTypesHelper = /** @class */ (function () {
    function ProductApiTypesHelper() {
    }
    ProductApiTypesHelper.loadTypeDefs = function () {
        var loc = "".concat(__dirname, "/schemas/product-graphql");
        return __spreadArray(__spreadArray([], CommonTypesHelper_1.CommonTypesHelper.loadTypeDefs(), true), [
            fs.readFileSync("".concat(loc, "/GuaranteedCashValueRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UnearnedPremiumRatioRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DeathBenefitRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/IllustrationRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ProductSpecificationsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ProductDerivativesRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/MECTestRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PremiumResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GuaranteedCashValueResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UnearnedPremiumRatioResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DeathBenefitResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ProductSpecificationsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ProductDerivativesResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/MECTestResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/schema.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/FlatExtraEndDateRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/FlatExtraEndDateResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ContestabilityEndDateRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ContestabilityEndDateResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/BenefitEndDateRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/BenefitEndDateResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/MaximumLoanAmountRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/MaximumLoanAmountResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UncapitalizedInterestAmountRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UncapitalizedInterestAmountResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/LoanPaymentAmountRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/LoanPaymentAmountResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/RiderSpecificationsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/RiderSpecificationsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PremiumInterestRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PremiumInterestResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ReducedPaidUpRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ReducedPaidUpResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityBenefitRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityBenefitResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityProductSpecificationsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityProductSpecificationsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityIllustrationResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityCASSVIllustrationRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityCASSVIllustrationResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityProductSpecificationsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityProductSpecificationsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DividendRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DividendResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityEffectiveAgeRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityEffectiveAgeResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AlirUnitRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AlirUnitResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AlirMaxResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/EffectiveDeathBenefitRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/EffectiveDeathBenefitResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AccidentalDeathBenefitRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AccidentalDeathBenefitResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GroupSpecificationsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GroupSpecificationsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CIRRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CIRResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityPremiumRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityPremiumResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/NetPaymentIndexRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/NetPaymentIndexResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CashValueLienRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CashValueLienResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/SequenceRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/SequenceResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/SequenceRangeResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/NetSinglePremiumRateListRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/NetSinglePremiumRateListResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityClaimRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityClaimResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/TermIllustrationResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/APRRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/APRResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityEndorsementsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityEndorsementsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PremiumSolveRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PremiumSolveResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DaysToYearsRatioRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DaysToYearsRatioResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CirClaimIllustrationResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityContractValueRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AnnuityContractValueResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/WithdrawalRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/WithdrawalResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/WithholdingRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/WithholdingResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PartialSurrenderRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PartialSurrenderResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ExtendedTermInsuranceRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ExtendedTermInsuranceResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/MECTestNewRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/MECTestNewResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CurrentCostBasisRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CurrentCostBasisResponse.graphql"), 'utf8'),
        ], false);
    };
    return ProductApiTypesHelper;
}());
exports.ProductApiTypesHelper = ProductApiTypesHelper;
//# sourceMappingURL=ProductApiTypesHelper.js.map